
    
    "use strict";

    export class Logger {

    constructor($options) {
        this.debug = $options.debug ? true : false;
    }

    store() {
        this.debug
            && console
                && console.log
                    && console.log.apply(console, arguments);
    }

}


// WEBPACK FOOTER //
// ./tbo/js/util/log.js